type FooterMenuLabelProps = {
  text: string;
};

export const FooterMenuLabel = ({ text }: FooterMenuLabelProps) => {
  return <span className="mb-1.5 block font-bold">{text}</span>;
};
